<template>
    <b-table-simple responsive fixed>
        <thead>
            <tr>
                <th width="3%">
                    <Check 
                        v-model="masterCheck" 
                        @change="checked => $emit('handlerMasterSelect', checked)"
                    />
                </th>
                <th><Ellipsis>Laboratório</Ellipsis></th>
                <th><Ellipsis>Item</Ellipsis></th>
                <th><Ellipsis>Cód. Apres</Ellipsis></th>
                <th><Ellipsis>Apresentação</Ellipsis></th>
                <th><Ellipsis>Cód. TISS</Ellipsis></th>
                <th><Ellipsis>Cód. TUSS</Ellipsis></th>
                <th><Ellipsis>EAN</Ellipsis></th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(brasindice, index) in brasindices" :key="index">
                <td>
                    <Check 
                        :value="selecteds.includes(brasindice.id)" 
                        @input="checked => !checked && masterCheck ? (masterCheck = false) : null"
                        @change="$emit('handlerSelect', brasindice)" 
                    />
                </td>
                <td>{{ brasindice.lab }}</td>
                <td>{{ brasindice.item }}</td>
                <td>{{ brasindice.cod_apres }}</td>
                <td>{{ brasindice.apres }}</td>
                <td>{{ brasindice.cod_tiss }}</td>
                <td>{{ brasindice.cod_tuss }}</td>
                <td>{{ brasindice.ean }}</td>
                <td>
                    <div class="actions">
                        <a>
                            <Edit  v-if="brasindice.table_number"
                                class="icon green" 
                                v-b-tooltip.hover.rightbottom title="Editar Campos adicionais já existentes"
                                @click="() => $emit('editExtras', brasindice)"
                            />
                            <Edit  v-else
                                class="icon" 
                                v-b-tooltip.hover.rightbottom title="Adicionar Campos adicionais"
                                @click="() => $emit('editExtras', brasindice)"
                            />
                        </a>
                        <a :href="`/matmed/exceptions/${tableId}/brasindice/${brasindice.id}`">
                            <Exceptions 
                                class="icon" 
                                v-b-tooltip.hover title="Ver exceções"
                            />
                        </a>
                        <a :href="`/tables/${tableId}/matmed/${brasindice.id}`">
                            <Update 
                                class="icon" 
                                v-b-tooltip.hover title="Ver atualizações"
                            />
                        </a>
                    </div>
                </td>
            </tr>
        </tbody>
    </b-table-simple>
</template>

<script>
import { parseCDType } from '@itemOtherExpenseProps/utils/constants'

export default {
    components: {
        Ellipsis: () => import('@/components/General/Ellipsis'),   
        Check: () => import('@/components/General/Check'),
        Exceptions: () => import('@matMed/assets/icons/exceptions.svg'),
        Update: () => import('@matMed/assets/icons/update.svg'),
        Edit: () => import('@/assets/icons/edit.svg'),
    },
    props: {
        tableId: String,
        brasindices: {
            type: Array,
            default: []
        },
        selecteds: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            masterCheck: false
        }
    },
    methods: {
        parseCDType,
        deleteItem(brasindice) {
            this.$swal({
                icon: 'question',
                html: `<div class="body-alert">Deseja realmente excluir o Item <span>${brasindice?.item}</span>?</div>`,
                showCancelButton: true,
                confirmButtonColor: '#F63220',
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
            }).then(res => {
                if (res.isConfirmed) {
                    this.$emit('delete', brasindice)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/table.scss';
.icon {
    width: 24px;
    height: 24px;
    cursor: pointer;


    &.green{
        stroke: darkgreen;
    }
}

</style>